import { StyleSheet } from 'aphrodite';
import { titles } from '../../../../../../web/styles/colors';
import { BreakPoints } from '../../../../../../web/styles/styles';

export const styleSheet = StyleSheet.create({
	clipboardMessage: {
		color: '#046CB6',
		fontSize: 14,
		lineHeight: '23px',
		margin: '0 auto',
		maxWidth: 372,
	},
	container: {},
	feedbackContainer: {
		fontSize: 14,
	},
	feedbackContainerHeader: {
		alignItems: 'center',
		color: titles,
		display: 'flex',
		justifyContent: 'space-between',
		marginBottom: 4,
	},
	feedbackInput: {
		height: 150,
		resize: 'none',
	},
	link: {
		display: 'inline-block',
		position: 'relative',
	},
	linkContainer: {
		height: 114,
		position: 'relative',
		[BreakPoints.phoneCompactWidth]: {
			margin: '0 auto',
			width: 230,
		},
	},
	linkContainerContent: {
		background: '#E8F3F9',
		borderRadius: 16,
		bottom: 0,
		boxSizing: 'border-box',
		cornerRadius: 18,
		left: 0,
		padding: '27px 38px 20px',
		position: 'relative',
		right: 0,
		top: 0,
		width: '100%',
		zIndex: 1,
		[BreakPoints.phoneCompactWidth]: {
			padding: `38px 10px`,
		},
	},
	linkContainerLeftBackgroundImage: {
		bottom: -18,
		left: -90,
		position: 'absolute',
		zIndex: 0,
		[BreakPoints.phoneCompactWidth]: {
			height: 'auto',
			left: -56,
			width: 209,
		},
	},
	linkContainerLinkWrapper: {
		display: 'inline-block',
		position: 'relative',
		zIndex: 0,
	},
	linkContainerLinkWrapperArrowImage: {
		left: -92,
		position: 'absolute',
		top: 6,
		[BreakPoints.forMaxWidth(820)]: {
			display: 'none',
		},
	},
	linkContainerRightBackgroundImage: {
		position: 'absolute',
		right: -12,
		top: -26,
		zIndex: 0,
	},
	message: {
		alignSelf: 'center',
		maxWidth: 360,
		minWidth: 'auto',
	},
});
